import { PackageSettingsFormController } from '../controller/PackageSettingsFormController';
import { BaseWebComponentElement } from '../../../../framework/BaseWebComponentElement';
import { DeepPartial } from 'typeorm';
import { PackageData } from '../../../types/package-data';
import _ from 'lodash';
import { combineLatest, Observable } from 'rxjs';
import { SettingsFormData } from '../types/PackageSettingsFormViewData';
import { PackageType } from '../../../packagesGrid/types';
import { map } from 'rxjs/operators';
import { FormGroup } from '../../../../ui/gzForm/formGroup/form-group';

export class PackageSettingsFormWebComponent extends BaseWebComponentElement {
  public controller!: PackageSettingsFormController;
  private settingsFormData: SettingsFormData | null = null;
  private packageType: PackageType;

  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: PackageSettingsFormController,
    });
  }

  public get valid$(): Observable<boolean> {
    if (!this.controller.view.settingsTargetsStarted()) {
      return this.controller.view.formGroup.valid$;
    }

    return combineLatest([
      this.controller.view.formGroup.valid$,
      this.controller.view.dom.$settingsTargets.valid$,
    ]).pipe(
      map(([formGroupValid, settingsTargetsValid]) => {
        return formGroupValid && settingsTargetsValid;
      })
    );
  }

  public get value(): DeepPartial<PackageData> {
    const formGroup: FormGroup = this.controller.view.formGroup;
    const baseGeneralData: DeepPartial<PackageData> = {
      settings: {
        customDeployFolders: this.controller.getSelectedTargets(),
      },
    };
    const response = _.merge(formGroup.getValueRecursively(formGroup, true), baseGeneralData);

    if (!(formGroup.value as object)['settings']['useCustomInstallationPath']) {
      delete response.settings?.customInstallationPath;
    }

    if (!(formGroup.value as object)['setUninstallPassword']) {
      delete response.settings?.uninstallPassword;
    }

    return response;
  }

  public set companyId(companyId) {
    this.setAttribute('companyId', companyId);
  }

  public get companyId(): string {
    const value = this.getAttribute('companyId');
    return value ? value : '';
  }

  public setPackageData(packageData: PackageData | null): void {
    if (packageData === null) {
      this.settingsFormData = null;
      this.controller.view.dom.$settingsPasswordInput.Input.setFormValue('');
      return;
    }
    this.companyId = packageData.company.id;
    this.settingsFormData = {
      customDeployFolders: packageData.settings?.customDeployFolders,
      useCustomDeployFolder: packageData.settings?.useCustomDeployFolder,
      setUninstallPassword: packageData?.setUninstallPassword,
      useCustomInstallationPath: packageData.settings?.useCustomInstallationPath,
      customInstallationPath: packageData.settings?.customInstallationPath,
      uninstallPassword: packageData.settings?.uninstallPassword,
    } as SettingsFormData;
  }

  public getPackageData(): SettingsFormData | null {
    return this.settingsFormData;
  }

  public setPackageType(productType: PackageType): void {
    this.packageType = productType;
  }

  public getPackageType(): PackageType {
    return this.packageType;
  }

  public enableSettingsSection(): void {
    this.controller.enableSettingsSection().then().catch(console.error);
  }

  public get hasUnsavedChanges(): boolean {
    return this.controller.view.formGroup.hasUnsavedChanges || this.controller.view.dom.$settingsTargets.hasUnsavedChanges;
  }
}
